import { type RtkQueryLayers } from '../../core';
import { waitingRoomOGService } from './waitingRoom.og';

export const waitingRoomRTKQueryLayers: RtkQueryLayers = {
  reducers: {
    waitingRoomOGReducerFromLibrary: waitingRoomOGService.reducer,
  },
  middlewares: [waitingRoomOGService.middleware],
};
